import React from 'react';

import {
  Alert,
  Box,
  Stack,
  Typography,
} from '@mui/material';

import {
  GridColDef,
} from '@mui/x-data-grid';

import { FDataGrid } from '../grid';

type Props = {
  rows: any[];
  loading?: boolean;
  selectedTask: any | null;
};

export default class BudgetLineGridPanel
  extends React.PureComponent<Props> {

  private getRowId = (row: any) =>
    row.id
    ?? row.rid
    ?? row.budgetlineid;

  private money = (value: any) =>
    Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  private columns = (): GridColDef[] => [
    {
      field: 'accountcode',
      headerName: 'Account',
      width: 145,
    },
    {
      field: 'description',
      headerName: 'Description',
      minWidth: 220,
      flex: 1,
    },
    {
      field: 'quantity',
      headerName: 'Qty',
      width: 80,
      type: 'number',
    },
    {
      field: 'unitprice',
      headerName: 'Unit Price',
      width: 125,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: (value: any) =>
        this.money(value),
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 135,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: (value: any) =>
        this.money(value),
      cellClassName: 'budget-cell-computed',
    },
  ];

  render() {
    const rows = this.props.rows || [];

    const taskName =
      this.props.selectedTask?.name
      ?? this.props.selectedTask?.taskname
      ?? '';

    const total = rows.reduce(
      (sum, row) => sum + Number(row.amount || 0),
      0,
    );

    if (!rows.length) {
      return (
        <Box sx={{ mt: 1.5 }}>
          <Stack spacing={1}>
            <Typography variant="h6">
              Budget Lines
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
            >
              Task: {taskName}
            </Typography>

            <Alert severity="info">
              No budget lines have been planned for this Task.
            </Alert>

            <Stack
              direction="row"
              justifyContent="flex-end"
              spacing={1}
            >
              <Typography variant="body2">
                Task Budget
              </Typography>

              <Typography
                variant="body2"
                fontWeight={700}
              >
                {this.money(0)}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      );
    }

    return (
      <Box sx={{ mt: 1.5 }}>
        <FDataGrid
          title="Budget Lines"
          subtitle={`Task: ${taskName}`}
          rows={rows}
          columns={this.columns()}
          loading={this.props.loading}
          height={300}
          getRowId={this.getRowId}

          sx={{
            '& .budget-cell-computed': {
              bgcolor: 'success.lighter',
              fontWeight: 600,
            },
          }}
        />

        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={1}
          sx={{ mt: 1 }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
          >
            Task Budget
          </Typography>

          <Typography
            variant="subtitle2"
            fontWeight={700}
          >
            {this.money(total)}
          </Typography>
        </Stack>
      </Box>
    );
  }
}